/**
 * True for an absolute http(s) URL. Links typed into the board (PR, marathon
 * output, task PR) are shown to every viewer, so anything else is refused —
 * migration 0143 enforces the same rule in the database.
 */
export function isHttpUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:";
  } catch {
    return false;
  }
}
